import { Button, Grid } from "@mui/material";
import styled from "styled-components";

export const DetailPageHeaderWrapper = styled(Grid)`
    padding-bottom: ${({ theme }) => theme.spacing(6)};
    padding-top: ${({ theme }) => theme.spacing(4)};
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
`;

export const BackButton = styled(Button)`
    && {
        padding: 0;
    }
`;
